module.exports = __webpack_public_path__ + "static/media/web.2f6dba03.svg";